import React from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  PaginationContainer,
  PaginationButton,
  EmptyStateContainer,
  EmptyStateText,
  EmptyStateSubtext,
} from './CustomTable.styles';

const CustomTable = ({ columns, data, renderActions, currentPage, onPageChange, hasNextPage }) => {
  if (!data || data.length === 0) {
    return (
      <EmptyStateContainer>
        <EmptyStateText>Nenhum registro encontrado</EmptyStateText>
        <EmptyStateSubtext>Não há dados para exibir com os filtros selecionados.</EmptyStateSubtext>
      </EmptyStateContainer>
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.field}>{column.headerName}</TableCell>
            ))}
            {renderActions && <TableCell>Ações</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((column) => (
                <TableCell key={column.field}>{row[column.field]}</TableCell>
              ))}
              {renderActions && <TableCell>{renderActions(row)}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <PaginationContainer>
        <PaginationButton onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
          Anterior
        </PaginationButton>
        <span>Página {currentPage}</span>
        <PaginationButton onClick={() => onPageChange(currentPage + 1)} disabled={!hasNextPage}>
          Próxima
        </PaginationButton>
      </PaginationContainer>
    </TableContainer>
  );
};

CustomTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      headerName: PropTypes.string.isRequired,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderActions: PropTypes.func,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  hasNextPage: PropTypes.bool,
};

CustomTable.defaultProps = {
  renderActions: null,
  currentPage: 1,
  onPageChange: () => {},
  hasNextPage: false,
};

export default CustomTable;
